define("command-palette/command/command", ["exports", "lodash"], function (_exports, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.CommandIdentifierKey = _exports.CommandFactoryFnKey = _exports.Command = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  class Command {
    constructor() {
      _defineProperty(this, "commandId", this.klass.commandId);

      _defineProperty(this, "searchTerms", void 0);

      _defineProperty(this, "mandatoryTerms", void 0);

      if (!(0, _lodash.isString)(this.klass.commandId) || !(0, _lodash.isFunction)(this.klass.create)) {
        throw new Error('Command classes must be defined with `@command` decorator');
      }
    }

    get klass() {
      return this.constructor;
    }

    execute(input, query) {
      return this.action(input, query);
    }

  }

  _exports.Command = Command;
  const CommandIdentifierKey = 'commandId';
  _exports.CommandIdentifierKey = CommandIdentifierKey;
  const CommandFactoryFnKey = 'create';
  _exports.CommandFactoryFnKey = CommandFactoryFnKey;
  var _default = Command;
  _exports.default = _default;
});